// `mission` is the stored source kind for an Initiative's approvals.
const SOURCE_LABELS = {
  mission: 'Agent work',
  initiative: 'Agent work',
  branch: 'Proposed changes',
  automation: 'From an automation',
  communication: 'Email to send',
};

/** What an approval is about, in the same words wherever it is listed or reviewed. */
export const approvalSource = (approval) => SOURCE_LABELS[approval?.source_kind] || 'Approval';
